// extracted by mini-css-extract-plugin
module.exports = {"logoLeft":"CSidebar_logoLeft__2SXVd"};